export const UrlBypassExceptionMessage = [
  'Accounts/bot/'
]
